import React, {Component} from 'react';
import {Message, MessageHeader} from 'semantic-ui-react';

export default class Logout extends Component {
    render() {
        return (
            <div>
                <Message success={true}>
                    <MessageHeader>You have been successfully logged out..</MessageHeader>
                    <p>Please close your browser.</p>
                </Message>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Logout.tsx